import {filter, difference, keys, omit, keyBy, find, map, createReducer} from 'helpers';

export const subs = createReducer({}, {

  ACTIVITIES_UPDATE: (state, { subtasks, activity, generateId, select }) => {
    if (subtasks) {
      const current = map(subtasks, (sub, index) => ({
        ...sub,
        parentId: activity.id || generateId('activityId'),
        parentStatusId: '0',
        orderIndex: index + 1,
      }));
      const before = select('activities.details', { id: activity.id || generateId('activityId') }) || {};
      const removed = filter(before.subtasks, sub => !find(current, { id: sub.id }));
      if (current.length || removed.length) {
        return {
          ...omit(state, map(removed, 'id')),
          ...keyBy(current, 'id'),
        }
      }
    }
    return state;
  },

  ACTIVITIES_TOGGLE_SUBTASK: (state, { subtask }) => ({
    ...state,
    [subtask.id]: {
      ...state[subtask.id],
      status: state[subtask.id].status == 'Completed' ? '' : 'Completed',
    }
  }),

  ACTIVITIES_SUBTASK_STATUS_UPDATE: (state, { subtask, contextDate, data, generateId, select }) => {
    const parentRecord = {
      id: generateId('progress-record-for-' + subtask.parentId),
      count: 0,
      ...select('calendar.record', { id: subtask.parentId, date: contextDate }),
    }
    const virtualSubtask = {
      name: '',
      orderIndex: parentRecord.count,
      parentId: subtask.id,
      parentStatusId: parentRecord.id,
      id: generateId('virtual-subtask'),
      ...find(state, { parentId: subtask.id, parentStatusId: parentRecord.id, orderIndex: parentRecord.count }),
    }
    return {
      ...state,
      [virtualSubtask.id]: {
        ...virtualSubtask,
        ...data,
      }
    }
  },

  ACTIVITIES_DELETE: (state, action) => {
    const { subtasks = [] } = action.select('activities.details', { id: action.id }) || {};
    if (subtasks.length) {
      return omit(state, map(subtasks, 'id'));
    }
    return state;
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.subTasks);
    if (action.subTasks.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.subTasks, 'id'),
      }, removed);
    }
    return state;
  },

  ACTIVITIES_DUPLICATE: (state, action) => {
    const { subtasks = [] } = action.select('activities.details', { id: action.referenceId });
    const copies = subtasks.map(sub => ({
      ...sub,
      id: action.generateId(sub.id),
      parentId: action.generateId('activityId'),
    }));
    if (copies.length) {
      return {
        ...state,
        ...keyBy(copies, 'id'),
      }
    }
    return state;
  },

  GOALS_DUPLICATE: (state, action) => {
    if (action.activities.length) {
      const duplicated = [];
      action.activities.forEach(activity => {
        const { subtasks = [] } = action.select('activities.details', { id: activity.id }) || {};
        subtasks.forEach(subtask => duplicated.push({
          ...subtask,
          id: action.generateId('subtask'+subtask.id),
          parentId: action.generateId('activity'+subtask.parentId),
        }))
      });
      if (duplicated.length) {
        return {
          ...state,
          ...keyBy(duplicated, 'id'),
        }
      }
    }
    return state;
  },

  TESTING_DELETE_ALL: () => ({}),

});
